// extracted by mini-css-extract-plugin
export var arrow = "_iv-1";
export var content = "_iv-0";
export var highlighted = "_iv-2";